import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';

const routes: Routes = [
  { path: '', loadChildren: './layout/layout.module#LayoutModule'},
  { path: 'not-found', loadChildren: './layout/not-found/not-found.module#NotFoundModule' },
  { path: 'forgot-password', loadChildren: './layout/forgot-password/forgot-password.module#ForgotPasswordModule' },
  { path: '**', redirectTo: 'not-found' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts